<ng-container>
  <div class="header-wrapper">
    <h2>{{ title }}</h2>
    <span
      [ngStyle]="{ display: !selectedOption ? 'block' : 'none' }"
      class="sub-title"
      [innerHTML]="subTitle"
    ></span>
  </div>

  <div class="content-wrapper">
    <div
      *ngFor="let item of content"
      class="option-item"
      [ngClass]="selectedOption === item.value ? 'selected' : 'not-selected'"
      (click)="selectOption(item)"
    >
      <p class="option-title">{{ item.title }}</p>
      <p class="option-sub-title">{{ item.subTitle }}</p>
    </div>
  </div>

  <div class="wrap-button">
    <lib-button (click)="cancel()" [label]="'Cancel'" type="Secondary"></lib-button>
    <lib-button
      (click)="confirm()"
      [disabled]="selectedOption === ''"
      [label]="'Next'"
      type="Primary"
    ></lib-button>
  </div>
</ng-container>
